<form [formGroup]="dayForm">
    <div class="row topAndmargin">
        <div class="col">
            <app-time-select [label]="'pages.branches.deliveryTypeDialog.input.by'" formControlName="time"
                (timeChange)="onTimeChange()" [disabled]="disabled"
                [requiredErrorKey]="'pages.branches.timeSlotDialog.inputValidation.by.required'"
                [invalidErrorKey]="'pages.branches.timeSlotDialog.inputValidation.by.invalid'">
            </app-time-select>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col">
            <label>{{'pages.branches.deliveryTypeDialog.input.orderCutOff' | translate}}</label>
            <input type="number" min="1" max="48" formControlName="cutOff" class="form-control"
                (input)="onValueChange()" [attr.disabled]="!timeControl?.value ? '' : null"
                [required]="!timeControl?.value ? false : true">
            <div *ngIf="cutOffControl?.errors" class="feedback">
                <div *ngIf="cutOffControl?.errors?.['required']">
                    {{'pages.branches.timeSlotDialog.inputValidation.from.required' | translate}}
                </div>
                <div *ngIf="cutOffControl?.errors?.['min']">
                    {{'pages.branches.timeSlotDialog.inputValidation.from.min' | translate:
                    cutOffControl?.errors?.['min'] }}
                </div>
                <div *ngIf="cutOffControl?.errors?.['max']">
                    {{'pages.branches.timeSlotDialog.inputValidation.from.max' | translate:
                    cutOffControl?.errors?.['max'] }}
                </div>
            </div>
        </div>
        <div class="col">
            <label>{{'pages.branches.deliveryTypeDialog.input.maximumOrders' | translate}}</label>
            <input type="number" min="1" max="100" formControlName="maxOrders" class="form-control"
                (input)="onValueChange()" [attr.disabled]="!timeControl?.value ? '' : null"
                [required]="!timeControl?.value ? false : true">
            <div *ngIf="maxOrdersControl?.errors" class="feedback">
                <div *ngIf="maxOrdersControl?.errors?.['required']">
                    {{'pages.branches.timeSlotDialog.inputValidation.from.required' | translate}}
                </div>
                <div *ngIf="maxOrdersControl?.errors?.['min']">
                    {{'pages.branches.timeSlotDialog.inputValidation.from.min' | translate:
                    maxOrdersControl?.errors?.['min'] }}
                </div>
                <div *ngIf="maxOrdersControl?.errors?.['max']">
                    {{'pages.branches.timeSlotDialog.inputValidation.from.max' | translate:
                    maxOrdersControl?.errors?.['max'] }}
                </div>
            </div>
        </div>
    </div>
</form>